import { AppConfig } from '../../AppConfig';
import { ApiHelper } from '../helpers/ApiHelper';
import { Controller } from '../Controller';

export class UserMgr {
  userFb = null;
  userLocal = null;
  appUser = null;
  userSettings = null;
  defaultUserSettings = AppConfig.userDefaultSettings;
  currUserSettings = null;
  tkn = null;
  currentOrg = null;

  constructor() {
    this.setAppUser();
  }

  updateUserSettings(userSettings) {
    const orgId = this.currentOrg ? this.currentOrg._id : null
    const options = {
      endPoint: ApiHelper.makeUrlPath(['users', this.appUser._id, 'settings'], { orgId: orgId }),
      jsonBody: {
        settings: userSettings
      },
      method: 'POST'
    }

    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
        })
        return
      } else {
        this.currUserSettings = userSettings
      }
    }.bind(this))
  }

  updateWithDefaultSettings(settings) {
    if (settings) {
      if (settings.ALERT_EMAIL === undefined) {
        settings.ALERT_EMAIL = this.defaultUserSettings.ALERT_EMAIL;
      }
      if (settings.EVENT_VISIBILITY === undefined) {
        settings.EVENT_VISIBILITY = this.defaultUserSettings.EVENT_VISIBILITY;
      }
      if (settings.EVENT_EMAIL_ALERT === undefined) {
        settings.EVENT_EMAIL_ALERT = this.defaultUserSettings.EVENT_EMAIL_ALERT;
      }
      if (settings.CAMERAS === undefined) {
        settings.CAMERAS = this.defaultUserSettings.CAMERAS;
      }
    } else {
      settings = this.defaultUserSettings
    }
    return settings
  }

  setFullScreenMode(fullscreenMode) {
    if (fullscreenMode) {
      localStorage.setItem('fullscreenMode', JSON.stringify('ON'))
    } else {
      localStorage.removeItem('fullscreenMode');
    }
  }

  getFullScreenMode() {
    const fullscreenMode = localStorage.getItem('fullscreenMode')
    if (fullscreenMode) {
      return fullscreenMode
    }
    return null;
  }

  setloggedInUserLocal(user) {
    return new Promise((resolve, reject) => {
      this.userLocal = {
        type: 'local',
        token: user.token
      }
      localStorage.setItem('userLocal', JSON.stringify(this.userLocal))
      let userEndpoint = ApiHelper.makeUrlPath(['users', 'me'])
      if (this.currentOrg) {
        userEndpoint = ApiHelper.makeUrlPath(['users', 'me'], { orgId: this.currentOrg._id })
      }
      const that = this;

      ApiHelper.call({ method: 'GET', endPoint: userEndpoint }, function (err, data) {
        if (!err) {
          that.appUser = data.appUser;
          localStorage.setItem('appUser', JSON.stringify(that.appUser))

          that.handleCurrentOrg(that.appUser)

          let settings = {};

          if (data.userSettings && Object.keys(data.userSettings).length) {
            settings = data.userSettings;
          }

          settings = that.updateWithDefaultSettings(settings)
          that.currUserSettings = settings;
          that.updateUserSettings(settings);

          that.setAppUser()

          resolve(true);
        } else {
          reject(err);
        }
      });
    })
  }

  updateCurrentOrg(currentOrg) {
    localStorage.removeItem('currentOrg');
    localStorage.setItem('currentOrg', JSON.stringify(currentOrg))
    this.currentOrg = currentOrg
  }

  updateFilterSettings(saveFilters) {
    console.log('updateFilterSettings', saveFilters)
    localStorage.setItem('saveFilters', JSON.stringify({ saveFilters: saveFilters }))
    this.saveFilters = saveFilters
  }

  getFilterSettings() {
    const saveFiltersStr = localStorage.getItem('saveFilters')
    if (saveFiltersStr) {
      const saveFiltersJson = JSON.parse(saveFiltersStr)
      this.saveFilters = saveFiltersJson.saveFilters
      return this.saveFilters
    } else {
      return null
    }
  }

  updatePriorityFilters = (priorityFilters) => {
    console.log('priorityFilters', priorityFilters)
    localStorage.setItem('priorityFilters', JSON.stringify({ priorityFiltersData: priorityFilters }))
    this.priorityFilters = priorityFilters
  }

  updateTagFilters = (tagFilters) => {
    console.log('updateFilterSettings', tagFilters)
    localStorage.setItem('tagFilters', JSON.stringify({ tagFiltersData: tagFilters }))
    this.tagFilters = tagFilters
  }

  getPriorityFilters() {
    if (!this.getFilterSettings()) {
      return []
    }
    const priorityFiltersStr = localStorage.getItem('priorityFilters')
    if (priorityFiltersStr) {
      const priorityFiltersJson = JSON.parse(priorityFiltersStr)
      this.priorityFilters = priorityFiltersJson.priorityFiltersData
      return this.priorityFilters
    } else {
      return []
    }
  }

  getTagFilters() {
    if (!this.getFilterSettings()) {
      return []
    }
    const tagFiltersStr = localStorage.getItem('tagFilters')
    if (tagFiltersStr) {
      const tagFiltersJson = JSON.parse(tagFiltersStr)
      this.tagFilters = tagFiltersJson.tagFiltersData
      return this.tagFilters
    } else {
      return []
    }
  }

  handleCurrentOrg(appUser) {
    const currentOrg = localStorage.getItem('currentOrg');
    if (!currentOrg &&
      !this.currentOrg &&
      appUser &&
      appUser.orgs &&
      appUser.orgs.length > 0) {
      localStorage.removeItem('currentOrg');
      localStorage.setItem('currentOrg', JSON.stringify(appUser.orgs[0]))
      this.currentOrg = appUser.orgs[0]
    } else if (currentOrg) {
      this.currentOrg = JSON.parse(currentOrg);
      let orgFound = false
      if (appUser.orgs) {
        for (const org of appUser.orgs) {
          if (org._id === this.currentOrg._id) {
            orgFound = true
            this.currentOrg = org;
            localStorage.removeItem('currentOrg');
            localStorage.setItem('currentOrg', JSON.stringify(org))
            break
          }
        }
      }
      if (!orgFound) {
        localStorage.removeItem('currentOrg');
        this.currentOrg = null
      }
    } else if (appUser && appUser.orgs && appUser.orgs.length > 0) {
      localStorage.setItem('currentOrg', JSON.stringify(appUser.orgs[0]))
      this.currentOrg = appUser.orgs[0]
    } else {
      localStorage.removeItem('currentOrg');
      this.currentOrg = null
    }
  }

  getUser() {
    return this.appUser;
  }

  setAppUser() {
    const appUser = localStorage.getItem('appUser');
    if (appUser && !this.appUser) {
      this.appUser = JSON.parse(appUser);
    }
    console.log('setAppUser', this.appUser)
    const currentOrg = localStorage.getItem('currentOrg');
    if (currentOrg && !this.currentOrg) {
      this.currentOrg = JSON.parse(currentOrg);
    }
  }

  getloggedInUser() {
    const user = this.userFb || this.userLocal;
    if (!user) {
      const userLocal = localStorage.getItem('userLocal')
      if (userLocal) {
        this.userLocal = JSON.parse(userLocal);
        return this.userLocal;
      }
    }
    if (user) {
      //console.log("getloggedInUser type:", user.type||'fib');
    } else {
      //console.log("getloggedInUser:", user);
    }
    return user;
  }

  checkUserPermission(url, loc) {
    console.log('checkUserPermission', url, loc)
    if (this.isProductUser()) {
      return true
    } else if (loc.path === '/orgs' || loc.path === '/orgs/') {
      if (this.isProductUser()) {
        return true
      } else {
        return false
      }
    } else if ((loc.path).startsWith('/orgs')) {
      const orgId = (loc && loc.params) ? loc.params.id : ''
      if (this.appUser && this.appUser.orgs && this.appUser.orgs.length) {
        for (const org of this.appUser.orgs) {
          if (org._id === orgId) return true
        }
      }
      return false
    }
    //TODO: for places urls, at this point we don't have org information regarding the particular place, so we allow all
    return true;
  }

  isProductUser() {
    if (this.appUser && this.appUser.orgs && this.appUser.orgs.length) {
      for (const org of this.appUser.orgs) {
        if (org._id === 'PRODUCT') {
          return true
        }
      }
    }
    return false;
  }

  isAdminUser() {
    if (this.currentOrg &&
      this.currentOrg.roles &&
      this.currentOrg.roles.length &&
      this.currentOrg.roles.indexOf('ADMIN') > -1) {
      return true
    }
    return false;
  }

  getOrgId() {
    if (this.currentOrg && this.currentOrg._id) {
      return this.currentOrg._id
    }
    return null;
  }

  getCurrentOrg() {
    return this.currentOrg
  }

  getUserSettings() {
    if (this.currUserSettings) {
      return this.currUserSettings;
    } else {
      return this.defaultUserSettings;
    }
  }

  getProductLogo() {
    if (this.currentOrg && this.currentOrg.logoUrl) {
      return this.currentOrg.logoUrl
    }
    return null;
  }

  signOut() {
    this.userFb = null;

    this.userLocal = null;
    localStorage.removeItem('userLocal')
    localStorage.removeItem('fullscreenMode');
    localStorage.removeItem('appUser');
    localStorage.removeItem('currentOrg');

    this.appUser = null;
    this.currentOrg = null;
    this.currUserSettings = null;
    Controller.get().pushRoute('/login');
  }

  navigateUserToHome() {
    const home = this.getUserHome();
    Controller.get().pushRoute(home);
  }


  getUserHome() {
    if (this.appUser && this.appUser.orgs && this.appUser.orgs.length) {
      if (this.appUser.orgs[0]['_id'] === 'PRODUCT') {
        return AppConfig.adminDashboard;
      } else if (this.appUser.orgs &&
        this.appUser.orgs[0].roles &&
        this.appUser.orgs[0].roles[0] === 'RESIDENT') {
        return '/orgs/' + this.currentOrg._id + '/guests'
      } else {
        return '/orgs/' + this.currentOrg._id + '/places'
      }
    }
    //TODO: show some page if user is not part of any org
  }

  getMyOrgId() {
    if (this.currentOrg && this.currentOrg) {
      return this.currentOrg._id;
    }
  }

  getUserId() {
    if (this.appUser) {
      return this.appUser._id;
    } else {
      return null;
    }
  }

  getloggedInUserTkn() {
    if (this.tkn) {
      return this.tkn;
    } else {
      return null;
    }
  }

  setloggedInUserTkn(tkn) {
    this.tkn = tkn;
  }


}



// WEBPACK FOOTER //
// ./src/common/mgrs/UserMgr.js